import { render } from "./ReportTwoView.vue?vue&type=template&id=2c16e927&scoped=true&ts=true"
import script from "./ReportTwoView.vue?vue&type=script&lang=ts"
export * from "./ReportTwoView.vue?vue&type=script&lang=ts"

import "./ReportTwoView.vue?vue&type=style&index=0&id=2c16e927&lang=scss&scoped=true"

import exportComponent from "C:\\vue项目\\fushuliang2024\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c16e927"]])

export default __exports__